import React from "react";
import { createBrowserRouter } from "react-router-dom";
import { ROUTES_OBJECT } from "./utils/Routes";
import PdfView from "./components/pdfView";
import VideoView from "./components/videoView";
import FavoriteFlash from "./pages/FavoriteFlash";
import {
  Home,
  Shop,
  Login,
  MyAccount,
  Card,
  ProductSingle,
  Wishlist,
  ShopResult,
  About,
  Contact,
  Blog,
  Flash,
  RegistrationOfCooperation,
} from "./pages";
import ErrorPage from "./pages/Errors/ErrorBoundary";
import Error404 from "./pages/Errors/Error404";
import Layout from "./layout";
import MyLibrary from "./pages/MyLibrary";
import Consultation from "./pages/consultation/Consultation.jsx";
import SingleBlog from "./components/SingleBlog";
import InstallGuide from "./pages/install-guide/InstallGuide";
import DigiPayPayment from "./pages/digiPayPayment/DigiPayPayment";
import SnappPayPayment from "./pages/snappPayPayment/snappPayPayment";

export const router = createBrowserRouter([
  {
    path: ROUTES_OBJECT.HOME,
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.CONSULTAION,
    element: (
      <Layout>
        <Consultation />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.SINGLEBLOG,
    element: (
      <Layout>
        <SingleBlog />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.REGISTRATIONOFCOOPERATION,
    element: (
      <Layout>
        <RegistrationOfCooperation />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.DIGIPAYPAYMENT,
    element: (
      <Layout>
        <DigiPayPayment />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.SNAPPPAYPAYMENT,
    element: (
      <Layout>
        <SnappPayPayment />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.INSTALLGUIDE,
    element: (
      <Layout>
        <InstallGuide />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.FLASH,
    element: (
      <Layout>
        {/* @ts-ignore */}
        <Flash />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.FAVORITEFLASH,
    element: (
      <Layout>
        <FavoriteFlash />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },

  {
    path: ROUTES_OBJECT.ABOUT,
    element: (
      <Layout>
        <About />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.CONTACT,
    element: (
      <Layout>
        <Contact />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.MYLIBRARY,
    element: (
      <Layout>
        <MyLibrary />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.SHOP,
    element: (
      <Layout>
        <Shop />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.PDFVIEW,
    element: (
      <Layout>
        <PdfView />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.VIDEOVIEW,
    element: (
      <Layout>
        <VideoView />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.LOGIN,
    element: (
      <Layout>
        <Login />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },

  {
    path: ROUTES_OBJECT.MYACCOUNT,
    element: (
      <Layout>
        <MyAccount />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.CARD,
    element: (
      <Layout>
        <Card />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.WISHLIST,
    element: (
      <Layout>
        <Wishlist />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.BLOG,
    element: (
      <Layout>
        <Blog />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.SINGLEBLOG,
    element: (
      <Layout>
        <SingleBlog />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.PRODUCT,
    element: (
      <Layout>
        <ProductSingle />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.SEARCH,
    element: (
      <Layout>
        <ShopResult />
      </Layout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES_OBJECT.ERROR404,
    element: <Error404 />,
    errorElement: <ErrorPage />,
  },
]);
